import { render } from "./AddDieselCost.vue?vue&type=template&id=0f00e489&scoped=true"
import script from "./AddDieselCost.vue?vue&type=script&lang=js"
export * from "./AddDieselCost.vue?vue&type=script&lang=js"

import "./AddDieselCost.vue?vue&type=style&index=0&id=0f00e489&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f00e489"]])

export default __exports__